exports.selectedTimeRangeAPIConfig = state => state.config.selectedTimeRange.apiConfig;

exports.getEncodedParams = state => ({
    start: encodeURIComponent(exports.selectedTimeRangeAPIConfig(state).start()
        .format('YYYY-MM-DD')),
    end: encodeURIComponent(exports.selectedTimeRangeAPIConfig(state).end()
        .format('YYYY-MM-DD'))
});



// WEBPACK FOOTER //
// ./src/helpers/encodeParams.js